<div class="pie-chart" id="chart1" (window:resize)="onResize($event)"></div>